// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exchange-rates-table__header {
  text-align: left;
  font-weight: bold;
  border-right: 1px dashed #213555 !important;
}
.exchange-rates-table__header__rates {
  text-align: center;
  font-weight: bold;
  border-right: 1px dashed #213555;
}
@media (max-width: 720px) {
  .exchange-rates-table__header__rates {
    border-right: none;
  }
}
.exchange-rates-table__header__percentage-changes-over-periods {
  text-align: center;
  font-weight: bold;
  background-color: #ebd9cd;
  border-bottom: 1px dashed #213555;
}`, "",{"version":3,"sources":["webpack://./src/sections/RatesSection/components/ExchangeRatesTableHeaders.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,iBAAA;EACA,2CAAA;AADF;AAGE;EACE,kBAAA;EACA,iBAAA;EACA,gCAAA;AADJ;AAGI;EALF;IAMI,kBAAA;EAAJ;AACF;AAGE;EACE,kBAAA;EACA,iBAAA;EACA,yBCfU;EDgBV,iCAAA;AADJ","sourcesContent":["@use \"../../../utils/themeConstants\";\r\n\r\n.exchange-rates-table__header {\r\n  text-align: left;\r\n  font-weight: bold;\r\n  border-right: 1px dashed themeConstants.$color-dark !important;\r\n\r\n  &__rates {\r\n    text-align: center;\r\n    font-weight: bold;\r\n    border-right: 1px dashed themeConstants.$color-dark;\r\n\r\n    @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n      border-right: none;\r\n    }\r\n  }\r\n  \r\n  &__percentage-changes-over-periods {\r\n    text-align: center;\r\n    font-weight: bold;\r\n    background-color: themeConstants.$color-light;\r\n    border-bottom: 1px dashed themeConstants.$color-dark;\r\n  }\r\n}","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
